import { getInitialProgress, isLegacyProgress } from './colorMemoryLogic';

const STORAGE_KEY = 'coloBongo_colorMemory_progress';

function normalizeProgress(raw) {
  if (!raw || isLegacyProgress(raw)) return getInitialProgress();
  return { ...getInitialProgress(), ...raw };
}

export async function loadProgress(user, supabase) {
  if (user && supabase) {
    try {
      const { data, error } = await supabase
        .from('user_game_progress')
        .select('progress_data')
        .eq('user_id', user.id)
        .eq('game_key', 'color_memory')
        .single();
      if (data && !error) return normalizeProgress(data.progress_data);
    } catch (e) {
      // fallback to localStorage
    }
  }
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return normalizeProgress(JSON.parse(stored));
  } catch (e) {
    // ignore
  }
  return getInitialProgress();
}

export async function saveProgress(progress, user, supabase) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
  } catch (e) {
    // ignore
  }
  if (user && supabase) {
    try {
      await supabase
        .from('user_game_progress')
        .upsert(
          {
            user_id: user.id,
            game_key: 'color_memory',
            progress_data: progress,
            updated_at: new Date().toISOString(),
          },
          { onConflict: 'user_id,game_key' }
        );
    } catch (e) {
      // ignore
    }
  }
}

export async function addXpToGlobal(xp, user, supabase) {
  if (!user || !supabase || xp <= 0) return;
  try {
    await supabase.rpc('add_user_xp', {
      p_user_id: user.id,
      p_xp_delta: xp,
      p_reason: 'game_color_memory',
    });
  } catch (e) {
    // ignore
  }
}
